require('./es6.array.iterator');
var Iterators = require('./$.iterators');
Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/modules/web.dom.iterable.js
// module id = 822
// module chunks = 14